import {Card, Divider, Theme} from '@oneamerica/dxp-ui-components';
import React from 'react';
import {Linking, View, Text} from 'react-native';
import {faFaceThinking} from '@fortawesome/pro-regular-svg-icons/faFaceThinking';
import {FontAwesomeIcon} from '@fortawesome/react-native-fontawesome';
import responsiveStyles from './styles';
import ColorConstants from '../../constants/ColorConstants';
import {common} from "../../config/languages/en.json"

interface ErrorModalProps {
  visible?: boolean;
}

const ErrorModal: React.FC<ErrorModalProps> = ({
  visible = true,
}) => {
  const styles = responsiveStyles();

  // Don't render if not visible
  if (!visible) {
    return null;
  }

  return (
    <View className='w-full px-4 max-w-md mx-auto'>
      <Card>
        <View className='p-4 md:p-6'>
          <View style={{alignItems:'center'}}>
            <FontAwesomeIcon
              icon={faFaceThinking}
              size={50}
              color={Theme.Color.oaBlueDark}
              style={{justifyContent: 'center'}}
            />
          </View>
          <View>
            <Divider />
          </View>
          <View>
            <Text style={styles.errorInfo}>
              Account information is not currently available. If you have any
              questions, please reference the{' '}
              <Text
              testID='contact-link'
                onPress={() =>
                  Linking.openURL('https://www.oneamerica.com/contact-us')
                }
                style={{
                  color: ColorConstants.oaBlue,
                }}>
                {common.contactUsLinkTitle}
              </Text>{' '}
              page.
            </Text>
          </View>
        </View>
      </Card>
    </View>
  );
};

export default ErrorModal;
